import { motion } from "framer-motion";
import { useLocation, NavLink, Link } from "react-router-dom";
import { useEffect, useState} from 'react';

const TokenDetails = props => {
    const location = useLocation();
    const [hasGifGenerator, setHasGifGenerator] = useState(false);

    useEffect(()=>{
      if (location.pathname === "/gallery") { setHasGifGenerator(true) }
    },[]);

    const handleCopyLink = () => {
      navigator.clipboard.writeText("https://rinkebyapi.artblocks.io/generator/" + props.token.vid);
      props.setModal({enabled:true, message:"A link to the artwork has been copied to clipboard.", type:"success"});

    }

   

    const handleTwitterShare = () => {
      const url =   "https://twitter.com/intent/tweet?" 
                    + "url=" + encodeURI("https://rinkebyapi.artblocks.io/generator/" + props.token.vid)  
                    + "&text=" + encodeURI("I've minted Spectron token " + props.token.id + " on @artblocks_io!")
                    + "&related=artblocks_io";
      let windowOptions = 'width=550,height=420,scrollbars=yes,resizable=yes,toolbar=no,location=yes';
      window.open(url, 'intent', windowOptions);
    }

    return (
      <motion.footer 
        className={props.overlay ? "section is-overlay" : "section"}
        
        initial={{y:100, opacity:0}}
        animate={{y:0, opacity:1}}
        transition={{delay:0.1, duration:0.6}}  
      >
      <div className="columns is-mobile">
            <div className="column is-6">
              {props.hasSocials ? (
              <p className="is-size-7 buttons mt-1">
                  {props.hasBackButton && (<NavLink to="/gallery" className="button is-small is-primary is-inverted is-rounded is-outlined">&larr; Back</NavLink>) }
                  
                  <button onClick={handleTwitterShare} className="button is-small is-primary is-inverted is-rounded is-outlined"> 
                    <span className="icon is-small">
                      <i className="fa fa-twitter"></i>
                    </span>
                  </button>
                  
                  <button onClick={handleCopyLink} className="button is-small is-primary is-inverted is-rounded is-outlined is-mobile-hidden">
                    <span className="icon is-small">
                      <i className="fa fa-link"></i>
                    </span>
                  </button>

              
              </p>
              ) : (
                <>
                {hasGifGenerator ? 
                  <Link to={"/gif/"+ props.token.vid+"/"} className="button is-small is-primary is-inverted is-rounded is-outlined is-mobile-hidden">Generate GIF</Link>
                 : 
                 <p className="is-size-7">Powered by <a href="https://artblocks.io/project/17" rel="noreferrer" target="_blank">ArtBlocks.io</a></p>
                }
                </>
              )}
            </div>
            <div className="column is-2 sp-right-aligned editions">
              <div>
                <p className="sp-label">Showing</p>
                <p className="is-size-7">{props.token.id+1} / {props.blockchain.artblock.projectTokenInfo.maxInvocations}</p>
              </div>
            </div>
            <div className="column is-2 sp-right-aligned is-hidden-mobile">
              <div>
               <p className="sp-label">Token Id</p>
               <p className="is-size-7">SPC.{props.token.vid} <a href={"https://artblocks.io/token/"+props.token.vid} rel="noreferrer" target="_blank">&rarr;</a></p>
               </div>
            </div>
            <div className="column is-2 sp-right-aligned is-hidden-mobile">
              <div>
                <p className="sp-label">Owner</p>
                <p className="is-size-7">{props.token.ownerShort}</p>
                </div>
            </div>
  
          </div>
      </motion.footer>
    )
  };

  export default TokenDetails;